import { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import {
  MdSearch,
  MdDownload,
  MdMenuBook,
  MdClose,
  MdPictureAsPdf,
  MdInsertDriveFile,
  MdCalendarToday,
  MdOutlineFileDownload,
} from "react-icons/md";
import { IoBookSharp, IoChevronBack } from "react-icons/io5";
import Swal from "sweetalert2";
import "../../../assests/css/studentdashboard/StudentsNotes.css";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { useNavigate } from "react-router-dom";

/* ─── COMPONENT ──────────────────────────────────────────────────────────── */
const StudentNotes = () => {
  const navigate = useNavigate();
  const { loggedInStudent, baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [subjects, setSubjects] = useState([]);
  const [showDisputeModal, setShowDisputeModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const openNotesDispute = (note) => {
    console.log(note);

    navigate("/help/support", {
      state: {
        request_type: "notes_dispute",
        reference_id: note.id,
        teacher_id: note.ngteacher_id,
        issue_type: "Notes Issue",
      },
    });
  };

  const submitNotesDispute = () => {
    const formData = new FormData();
    formData.append("ngstudent_id", loggedInStudent.id);
    formData.append("reference_id", selectedNote.id);
    formData.append("request_type", "notes_dispute");
    formData.append("selectissue", issue);
    formData.append("describeissue", description);

    axios.post(`${baseUrl}/student/notes/createDispute`, formData)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [issue, setIssue] = useState("");
  const [description, setDescription] = useState("");
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [noteSearch, setNoteSearch] = useState("");

  const filteredNotes = selectedSubject
    ? selectedSubject.ngguesspaper.filter((n) =>
      n.fileName.toLowerCase().includes(noteSearch.toLowerCase()),
    )
    : [];

  const openSubject = (subject) => {
    console.log(subject);
    setSelectedSubject(subject);
    // setNoteSearch("");
  };

  const goBack = () => {
    setSelectedSubject(null);
    setNoteSearch("");
  };

  const fetchAllCoursesForNotes = () => {
    if (!loggedInStudent) {
      return;
    }
    console.log(loggedInStudent);
    const formData = new FormData();
    formData.append("ngstudent_id", loggedInStudent.id);
    axios
      .post(`${baseUrl}/student/notes/fetchAllCoursesForNotes`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log("Complete Response:", response.data);

        const programme = response.data?.course?.ngprogramme;
        console.log("Programme:", programme);

        const courses = programme?.ngcourses || [];
        console.log("Courses:", courses);

        setSubjects(courses);
      })
      .catch((error) => {
        console.log("API Error:", error.response?.data || error);
      });
  };

  useEffect(() => {
    if (loggedInStudent) {
      fetchAllCoursesForNotes();
    }
  }, [loggedInStudent]);

  return (
    <StudentsideLayout>
      <div className="sn-page">
        {/* ── Page Header ─────────────────────────────────────────────── */}
        <div className="sn-page-header">
          <div className="sn-header-left">
            {selectedSubject ? (
              <button
                className="sn-back-btn"
                onClick={goBack}
                aria-label="Back"
              >
                <IoChevronBack />
              </button>
            ) : (
              <div className="sn-header-icon">
                <IoBookSharp />
              </div>
            )}
            <div>
              <h1 className="sn-page-title">
                {selectedSubject ? selectedSubject.name : "My Notes"}
              </h1>
              <p className="sn-page-subtitle">
                {selectedSubject
                  ? `${selectedSubject.code} `
                  : "Select a subject to view and download notes"}
              </p>
            </div>
          </div>
        </div>

        {/* ── Subjects Grid ───────────────────────────────────────────── */}
        {!selectedSubject && (
          <Container fluid className="sn-container">
            {subjects.length === 0 ? (
              <div className="sn-empty">
                <MdMenuBook className="sn-empty-icon" />
                <p>No subjects found for "{searchQuery}"</p>
              </div>
            ) : (
              <Row className="g-4">
                {subjects.map((subject, index) => (
                  <Col
                    key={subject.id}
                    xs={12}
                    sm={6}
                    lg={4}
                    xl={3}
                    style={{ animationDelay: `${index * 0.07}s` }}
                  >
                    <div
                      className="sn-subject-card"
                      onClick={() => openSubject(subject)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) =>
                        e.key === "Enter" && openSubject(subject)
                      }
                      aria-label={`Open ${subject.name}`}
                    >
                      <div
                        className="sn-card-accent"
                        style={{ background: subject.color }}
                      />
                      <div className="sn-card-emoji">{subject.emoji}</div>
                      <div className="sn-card-body">
                        <h3 className="sn-card-title">{subject.name}</h3>
                        <p className="sn-card-code">{subject.code}</p>
                        <p className="sn-card-teacher">{subject.teacher}</p>
                      </div>
                      <div className="sn-card-footer">
                        <Badge className="sn-notes-badge">
                          <MdInsertDriveFile />
                          {subject.totalNotes} Notes
                        </Badge>
                        <span className="sn-card-arrow">→</span>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            )}
          </Container>
        )}

        {/* ── Notes List ──────────────────────────────────────────────── */}
        {selectedSubject && (
          <Container fluid className="sn-container">
            {/* Subject summary strip */}

            <div
              className="sn-subject-strip"
              style={{ borderLeft: `4px solid ${selectedSubject.color}` }}
            >
              <span className="sn-strip-emoji">{selectedSubject.emoji}</span>
              <div>
                <span className="sn-strip-title">{selectedSubject.name}</span>
                <span className="sn-strip-meta">
                  {selectedSubject.ngguesspaper.length} files available
                </span>
              </div>
            </div>

            {filteredNotes.length === 0 ? (
              <div className="sn-empty">
                <MdInsertDriveFile className="sn-empty-icon" />
                <p>No notes found for "{noteSearch}"</p>
              </div>
            ) : (
              <div className="sn-notes-list">
                {filteredNotes.map((note, index) => (
                  <div
                    key={note.id}
                    className="sn-note-row"
                    style={{ animationDelay: `${index * 0.06}s` }}
                  >
                    {/* File icon */}
                    <div
                      className={`sn-file-icon ${note.type === "pdf" ? "sn-pdf" : "sn-doc"
                        }`}
                    >
                      <p>Total Notes: {filteredNotes.length}</p>
                      {note.type === "pdf" ? (
                        <MdPictureAsPdf />
                      ) : (
                        <MdInsertDriveFile />
                      )}
                    </div>

                    {/* Note info */}
                    <div className="sn-note-info">
                      <h4 className="sn-note-title">{note.title}</h4>
                      <div className="sn-note-meta">
                        <span>
                          <MdCalendarToday />{" "}
                          {new Date(note.created_at).toLocaleDateString()}
                        </span>
                        <a target="_blank" href={`${baseUrlForFiles}/${note.fileName}`}>
                          <span
                            className={`sn-type-pill ${note.type === "pdf"
                              ? "sn-pill-pdf"
                              : "sn-pill-doc"
                              }`}
                          >
                            {note.fileName.toUpperCase()}
                          </span>
                        </a>
                      </div>
                    </div>
                    <div className="mt-2">
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => openNotesDispute(note)}>
                        Raise Dispute
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Container>
        )}
      </div>
    </StudentsideLayout>
  );
};

export default StudentNotes;